import { Field, reduxForm } from 'redux-form';
import React, { Component } from 'react';
import { renderTextField } from '../../components/reduxFields';
import { LoginButton, LoginButtonDisabled } from '../../components/buttons';
import { connect } from 'react-redux';
import { updateLoginUserPasswordAction } from './actions/LoginActions';

const validate = (values) => {
  const errors = {};
  if (!values.currentPassword) {
    errors.currentPassword = 'Please enter current password';
  }

  if (!values.confirmNewPassword) {
    errors.confirmNewPassword = 'Please confirm new password';
  } else if (values.confirmNewPassword !== values.newPassword) {
    errors.confirmNewPassword = 'Password mismatched';
  }

  if (!values.newPassword || values.newPassword.trim() === '') {
    errors.newPassword = 'Please enter new password';
  } else if (!/^(?=.{8,30}$)/.test(values.newPassword)) {
    errors.newPassword = 'Password should contain minimum 8 and maximum 30 characters';
  } else {
    let pError = [], prefix = '';
    if (!/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[\+\-\_\@\#\$\%\&\!\,\[\]\{\}\(\)\|])/.test(values.newPassword)) {
      prefix = 'Password should contain atleast ';
    }
    if (!/^(?=.*[a-z])/.test(values.newPassword)) {
      pError.push('1 lowercase character');
    }
    if (!/^(?=.*[A-Z])/.test(values.newPassword)) {
      pError.push('1 uppercase character');
    }
    if (!/^(?=.*[0-9])/.test(values.newPassword)) {
      pError.push('1 numeric value');
    }
    if (!/^(?=.*[\+\-\_\@\#\$\%\&\!\,\[\]\{\}\(\)\|])/.test(values.newPassword)) {
      pError.push('1 special character');
    }
    errors.newPassword = prefix + pError.join(', ');
  }

   // Check if the new password is same as the current password
   if (values.newPassword === values.currentPassword) {
    errors.newPassword = 'New password cannot be the same as current password';
  }

  return errors;
};


class UpdateLoginUserPassword extends Component {

  onSubmit = (formData) => {
    let postData = {
      'userId': this.props.loginUserId,
      'currentPassword': formData.currentPassword,
      'newPassword': formData.newPassword,
      'confirmNewPassword': formData.confirmNewPassword,
    };
    // console.log('final authdata', JSON.stringify(postData));
    this.props.updateLoginUserPasswordAction(postData, this.props.businessNameCheck);
  }

  render() {
    const { handleSubmit, errorMessage, redirectToLogin, loginHeaderComponent } = this.props;
    return (
      <div className="login-fields">
        {loginHeaderComponent}
        <form className="readmin-form custom_form" noValidate onSubmit={handleSubmit(this.onSubmit.bind(this))}>
          {errorMessage && (<div className="alert-danger">{errorMessage}</div>)}
          <div className ="row">
            <div className = "col-sm-12 require">
              <Field
                name='currentPassword'
                maxLength="30"
                type="password"
                label='Current Password'
                component={renderTextField} />
            </div>
            <div className ="col-sm-12 require">
              <Field
                name='newPassword'
                maxLength="30"
                type="password"
                label='New Password'
                component={renderTextField} />
            </div>
            <div className ="col-sm-12 require">
              <Field
                name='confirmNewPassword'
                maxLength="30"
                type="password"
                label='Confirm New Password'
                component={renderTextField} />
            </div>
          </div>
          <div className="pt20">
            {this.props.authenticating ? <LoginButtonDisabled label="Updating" /> : <LoginButton label="Update" />}
          </div>
          <div className="backtologin text-center"><div onClick={redirectToLogin}><i className="fa fa-long-arrow-left" aria-hidden="true"></i> Back to Login</div></div>
        </form>
      </div>
    );
  }
}

UpdateLoginUserPassword = reduxForm({
  form: 'UpdateLoginUserPasswordForm',
  validate,
  enableReinitialize: true, // this is needed!!
})(UpdateLoginUserPassword);

export default connect(null, { updateLoginUserPasswordAction })(UpdateLoginUserPassword);



// WEBPACK FOOTER //
// ./src/modules/logins/login_updatePassword.js